import {
  ERROR_ON_GETTING_MATERIAL_USAGE_OF_PRINTER, ERROR_ON_GETTING_PRINTS_NUMBER, RECEIVED_MATERIAL_USAGE_OF_PRINTER,
  RECEIVED_PRINTS_NUMBER,
  START_FETCHING_MATERIAL_USAGE_OF_PRINTER
} from "./types";
import axios from 'axios';
import {backendDomain} from "../modules/configs";

export const startFetchingMaterialUsageOfPrinter = (printerId) => dispatch => {
  dispatch({
    type: START_FETCHING_MATERIAL_USAGE_OF_PRINTER,
    payload: { [printerId]: { materialUsage: {loading: true} } }
  });
  return axios.get(`${backendDomain}/query/cumulative?printerId=${printerId}`, { headers: { Authorization: `Bearer ${localStorage.access_token}` } })
    .then(res => {
      dispatch(receivedMaterialUsageOfPrinter(res.data, printerId))
    })
    .catch(err => {
      dispatch(errorOnMaterialUsageOfPrinter(err, printerId))
    })
}

const receivedMaterialUsageOfPrinter = (materialUsageOfPrinter, printerId) => ({
  type: RECEIVED_MATERIAL_USAGE_OF_PRINTER,
  payload: { [printerId]: { materialUsage: materialUsageOfPrinter } }
})

const errorOnMaterialUsageOfPrinter = (error, printerId) => ({
  type: ERROR_ON_GETTING_MATERIAL_USAGE_OF_PRINTER,
  payload: { [printerId]: { materialUsage: error } }
})

export const startFetchingPrintsNumber = (printerId) => dispatch => {
  return axios.get(`${backendDomain}/query/printsNumber?printerId=${printerId}`, { headers: { Authorization: `Bearer ${localStorage.access_token}` } })
    .then(res => {
      dispatch(receivedPrintsNumber(res.data, printerId))
    })
    .catch(err => {
      dispatch(errorOnGettingPrintsNumber(err, printerId))
    })
}

const receivedPrintsNumber = (countObj, printerId) => ({
  type: RECEIVED_PRINTS_NUMBER,
  payload: { [printerId]: { printsNumber: countObj.printsNumber } }
})

const errorOnGettingPrintsNumber = (error, printerId) => ({
  type: ERROR_ON_GETTING_PRINTS_NUMBER,
  payload: { [printerId]: { printsNumber: error } }
})


// WEBPACK FOOTER //
// ./src/actions/getPrinterStatistics.js